<ui-modal-single heading="Attach Evidence">
  <ng-template #contentSlot>
    <div class="d-flex flex-column gap-4">
      <p class="fw-semibold">Attach Link</p>
      <div>
        <label class="m-label" for="title">Title*</label>
        <input type="text" class="form-control" id="title" name="title" aria-describedby="title"
          required placeholder="" [formControl]="evidenceForm().get('title')">
          <div *ngIf="evidenceForm().get('title').invalid && (evidenceForm().get('title').dirty || evidenceForm().get('title').touched)">
            <span class="f-caption text-danger pt-2" *ngIf="evidenceForm().get('title').errors.required">Title is required</span>
          </div>
      </div>
      <div>
        <label class="m-label" for="link">Link*</label>
        <input type="text" class="form-control" id="link" name="link" aria-describedby="link"
          placeholder="" [formControl]="evidenceForm().get('link')">
          <div *ngIf="evidenceForm().get('link').invalid && (evidenceForm().get('link').dirty || evidenceForm().get('link').touched)">
            <span class="f-caption text-danger pt-2" *ngIf="evidenceForm().get('link').errors.required">Link is required</span>
          </div>
      </div>
      <div>
        <label class="m-label" for="description">Description</label>
        <input type="text" class="form-control" id="description" name="description" aria-describedby="description"
          placeholder="" [formControl]="evidenceForm().get('description')">
      </div>
    </div>
      <!-- <div class="d-flex flex-wrap justify-content-start">
          <div [innerHTML]="content"></div>
      </div> -->
  </ng-template>
  <ng-template #rightSlot>
      <button type="button" class="btn btn-outline-light" (click)="close()">Close</button>
      <!-- <button *ngIf="hasSaveButton" (click)="onSaveAsDraft()" class="btn btn-secondary">Save as Draft</button> -->
      <button type="button" [disabled]="evidenceForm().invalid"
        class="btn btn-secondary" (click)="attachEvidence()">Attach Evidence</button>
  </ng-template>
</ui-modal-single>
